


import ActivityLogs from '../Logs';

  const AdminLogsTable = (
  ) => {

    return (
      <>
      
      <ActivityLogs isDashboard={true} />

      </>
      
    );
  };
  
  export default AdminLogsTable;
  